import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

const IframeModal = ({ show, onHide, url, title = 'Content', showSidebar = false }) => {
  const getUrlWithParams = (baseUrl) => {
    try {
      // If URL is relative, prepend the current origin
      const fullUrl = baseUrl.startsWith('http') ? baseUrl : `${window.location.origin}${baseUrl}`;
      const urlObj = new URL(fullUrl);
      if (!showSidebar && !urlObj.searchParams.has('show_sidebar')) {
        urlObj.searchParams.append('show_sidebar', 'false');
      }
      return urlObj.toString();
    } catch (error) {
      console.error('Error processing URL:', error);
      return baseUrl; // Return original URL if there's an error
    }
  };

  return (
    <Modal
      isOpen={show}
      toggle={onHide}
      size="xl"
      centered
      className="iframe-modal"
      style={{
        maxWidth: '90vw',
        margin: '0 auto'
      }}
    >
      
      <ModalHeader toggle={onHide}>
        {title}
      </ModalHeader>
      <ModalBody style={{ padding: 0 }}>
        <iframe
          src={getUrlWithParams(url)}
          style={{
            width: '100%',
            height: '80vh',
            border: 'none'
          }}
          title={title}
        />
      </ModalBody>
    </Modal>
  );
};

export default IframeModal;
